import { LoadingButton } from '@mui/lab';
import { Box, FormControl, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { aiProviders } from 'src/Helpers/constant';
import { aiConfigService } from 'src/Services/ApiHandlers/aiConfigServices';

const AIConfig = ({ content_id }) => {
  const [loading, setLoading] = useState(false);
  const [currentConfig, setCurrentConfig] = useState({
    model_provider: '',
    model_name: '',
  });

  useEffect(() => {
    const fetchAIConfig = async () => {
      const response = await aiConfigService.getAIConfig(content_id);
      setCurrentConfig(response.data);
    };
    fetchAIConfig();
  }, []);

  const updateAIConfig = async () => {
    try {
      setLoading(true);
      const data = {
        model_provider: currentConfig.model_provider,
        model_name: currentConfig.model_name,
        content_id: content_id,
      };
      await aiConfigService.updateAIConfig(data);
      toast.success('AI Config updated successfully');
    } catch (error) {
      console.log(error);
      toast.error('Failed to update AI Config');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '400px',
      }}
    >
      <Stack>
        <Box
          sx={{
            display: 'flex',
            flexDirection: {
              xs: 'column',
              md: 'row',
            },
            gap: 2,
          }}
        >
          <FormControl>
            <InputLabel variant="filled">Model</InputLabel>
            <Select
              sx={{
                width: {
                  xs: '100%',
                  md: '150px',
                },
              }}
              value={currentConfig?.model_provider}
              onChange={(e) => setCurrentConfig({ ...currentConfig, model_provider: e.target.value })}
            >
              {aiProviders.map((model) => (
                <MenuItem
                  key={model.id}
                  value={model.model_provider}
                  selected={currentConfig?.model_provider === model.model_provider}
                >
                  {model.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl>
            <TextField
              label="Model Name"
              variant="outlined"
              value={currentConfig?.model_name || ''}
              defaultValue={currentConfig?.model_name || ''}
              onChange={(e) => setCurrentConfig({ ...currentConfig, model_name: e.target.value })}
            />
          </FormControl>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <LoadingButton
            sx={{
              maxWidth: '150px',
              mt: '1rem',
            }}
            variant="contained"
            color="primary"
            onClick={updateAIConfig}
            loading={loading}
          >
            Update
          </LoadingButton>
        </Box>
      </Stack>
    </Box>
  );
};

export default AIConfig;
